import styles from '@/components/ConnectContainer.module.css'
import { useState } from 'react'
import AppStoreButtons from '@/components/ui/buttons/AppStoreButtons'
import { useNewsletter } from '@/api/users/user.api' // adjust path if different
//import { handleAnalytics } from "@/pages/api/analyticsHandler";

const ConnectContainer = () => {
  /* ------------------------------------------------------------------ */
  /*  local form state                                                  */
  /* ------------------------------------------------------------------ */
  const [email, setEmail] = useState('')
  const [emailValid, setEmailValid] = useState(false)
  const [helperText, setHelperText] = useState('')

  /* ------------------------------------------------------------------ */
  /*  newsletter mutation – React Query gives us nice status flags      */
  /* ------------------------------------------------------------------ */
  const {
    mutate: subscribe,
    isLoading,
    isError,
    error, // will hold the Error object if isError === true
  } = useNewsletter()

  /* ------------------------------------------------------------------ */
  /*  helpers                                                           */
  /* ------------------------------------------------------------------ */
  const validateEmail = (value) => {
    const pattern = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i
    return pattern.test(value)
  }

  const handleSubmit = () => {
    if (!emailValid) return

    subscribe(
      { email },
      {
        onSuccess: () => {
          setHelperText('Thanks for subscribing! 🎉')
        },
        onError: (err) => {
          const msg = err?.message || 'Something went wrong 😔'
          setHelperText(msg)
        },
      },
    )
  }

  return (
    <div className={styles.newsletter}>
      <div className={styles.section}>
        <div className={styles.sectionContent}>
          <div className={styles.sectionIntroduction}>
            <div className={styles.sectionSubtitle}>Stay connected</div>
            <div className={styles.sectionDescription}>
              Subscribe to our newsletter for the latest news and updates on ClearWatt&rsquo;s mission. We promise not
              to spam you.
            </div>
          </div>

          <form
            id="newsletter-form"
            className={styles.newsletterSubscription}
            onSubmit={(e) => {
              e.preventDefault()
              handleSubmit()
            }}
          >
            <div className={styles.inputControl}>
              <input
                type="email"
                value={email}
                onChange={(e) => {
                  const value = e.target.value
                  const isGood = validateEmail(value)

                  setEmail(value)
                  setEmailValid(isGood)
                  setHelperText(value === '' ? '' : isGood ? 'Email looks good ✅' : 'Invalid email format 🚨')
                }}
                id="email_nl"
                name="email_nl"
                placeholder="What’s your email?"
                className={styles.input_nl}
                required
              />

              <button type="submit" className={styles.buttonSubscribe} disabled={!emailValid || isLoading}>
                {isLoading ? 'Sending…' : 'Subscribe'}
              </button>
            </div>

            <div className={isError ? styles.stateError : styles.stateSuccess}>
              {isLoading ? 'Sending… ⏳' : helperText}
            </div>
          </form>
        </div>

        <div className={styles.buttonContainer}>
          <div className={styles.sectionDescriptionAlt}>Download our EV&nbsp;Health&nbsp;Test app</div>
          <AppStoreButtons theme="light" />
        </div>
      </div>
    </div>
  )
}

export default ConnectContainer
